import {WizardComponentController} from "../WizardComponent";

export const WizardPrevious = "wizardPrevious";

export function wizardPrevious() {
  return {
    restrict: "A",
    require: "^^tfWizard",
    link: ($scope: ng.IScope, $elem: ng.IRootElementService, $attr: ng.IAttributes, wizard: WizardComponentController) => {
      $elem.on("click", () => {
        wizard.previous();
      });
    }
  };
}
